import React from "react";
import AnchorSection from "./AnchorSection";
import FieldSection from "./FieldSection";
import TestSection from "./TestSection";

export default function ConfigPanel({
  selectedToken,
  anchors,
  setAnchors,
  fields,
  setFields
}) {
  return (
    <>
      <h3>Configuration</h3>

      <AnchorSection
        selectedToken={selectedToken}
        anchors={anchors}
        setAnchors={setAnchors}
      />

      <FieldSection
        anchors={anchors}
        fields={fields}
        setFields={setFields}
      />

      <TestSection />
    </>
  );
}
